(() => {
  'use strict';

  const path = window.location.pathname || '';
  if (!path.includes('/blogs/')) return;

  const locale = path.startsWith('/fr/') ? 'fr' : path.startsWith('/pl/') ? 'pl' : 'en';
  const copy = {
    en: { choose: 'Choose an option', add: 'Add to cart', adding: 'Adding…', added: 'Added ✓', sold: 'Sold out', error: 'Try again', view: 'View cart' },
    fr: { choose: 'Choisir une option', add: 'Ajouter au panier', adding: 'Ajout…', added: 'Ajouté ✓', sold: 'Épuisé', error: 'Réessayer', view: 'Voir le panier' },
    pl: { choose: 'Wybierz wariant', add: 'Dodaj do koszyka', adding: 'Dodawanie…', added: 'Dodano ✓', sold: 'Wyprzedane', error: 'Spróbuj ponownie', view: 'Zobacz koszyk' }
  }[locale];

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (locale === 'en' ? '/' : `/${locale}/`);

  function nextElement(node) {
    let n = node && node.nextSibling;
    while (n && n.nodeType !== 1) n = n.nextSibling;
    return n;
  }

  function listingSections() {
    const sections = [];
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_COMMENT);
    let node;
    while ((node = walker.nextNode())) {
      if ((node.nodeValue || '').trim() === 'SILUXE_PRODUCT_LISTING_V1') {
        const section = nextElement(node);
        if (section && section.tagName === 'SECTION') sections.push(section);
      }
    }
    return sections;
  }

  function handleFromHref(href) {
    try {
      const u = new URL(href, window.location.origin);
      const match = u.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (_) { return null; }
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    const selectors = [
      '[data-cart-count]',
      '.cart-count-bubble span:first-child',
      '#cart-icon-bubble .cart-count-bubble span:first-child',
      '.cart-count'
    ];
    document.querySelectorAll(selectors.join(',')).forEach((el) => {
      el.textContent = String(cart.item_count);
      const bubble = el.closest('.cart-count-bubble');
      if (bubble) bubble.hidden = cart.item_count < 1;
    });
  }

  async function refreshCartCount() {
    try {
      const r = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (r.ok) updateCartCount(await r.json());
    } catch (_) {}
  }

  async function enhanceCard(anchor) {
    if (!anchor || anchor.dataset.siluxeAtcReady === '1') return;
    const handle = handleFromHref(anchor.href);
    if (!handle) return;
    anchor.dataset.siluxeAtcReady = '1';

    let product;
    try {
      const r = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!r.ok) throw new Error('product');
      product = await r.json();
    } catch (_) {
      anchor.dataset.siluxeAtcReady = '0';
      return;
    }

    const variants = (product.variants || []).filter((v) => v.available !== false);
    const grid = anchor.parentElement;
    if (!grid) return;

    const card = document.createElement('div');
    card.setAttribute('data-siluxe-article-card', handle);
    card.style.cssText = 'border:1px solid rgba(33,33,33,.12);background:#fff;overflow:hidden;display:flex;flex-direction:column;min-width:0;';
    grid.insertBefore(card, anchor);
    card.appendChild(anchor);
    anchor.style.border = '0';
    anchor.style.flex = '1 1 auto';

    const purchase = document.createElement('div');
    purchase.style.cssText = 'padding:0 14px 14px;';
    purchase.setAttribute('data-siluxe-article-atc', 'v1');
    card.appendChild(purchase);

    const status = document.createElement('div');
    status.setAttribute('aria-live', 'polite');
    status.style.cssText = 'font-size:.8em;min-height:1.2em;margin-top:7px;opacity:.78;';

    const form = document.createElement('form');
    form.method = 'post';
    form.action = `${root}cart/add`;
    form.style.margin = '0';

    if (variants.length > 1) {
      const selector = document.createElement('select');
      selector.name = 'id';
      selector.setAttribute('aria-label', copy.choose);
      selector.style.cssText = 'width:100%;padding:10px 12px;border:1px solid #d9d3ca;border-radius:999px;background:#fff;color:#211f1b;margin:0 0 8px;font:inherit;font-size:.88em;';
      variants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = variant.public_title || variant.title || copy.choose;
        selector.appendChild(option);
      });
      form.appendChild(selector);
    } else if (variants.length === 1) {
      const id = document.createElement('input');
      id.type = 'hidden';
      id.name = 'id';
      id.value = String(variants[0].id);
      form.appendChild(id);
    }

    const qty = document.createElement('input');
    qty.type = 'hidden';
    qty.name = 'quantity';
    qty.value = '1';
    form.appendChild(qty);

    const button = document.createElement('button');
    button.type = 'submit';
    button.textContent = variants.length ? copy.add : copy.sold;
    button.disabled = !variants.length;
    button.style.cssText = 'width:100%;padding:11px 14px;border:1px solid #211f1b;border-radius:999px;background:#211f1b;color:#fff;font:inherit;font-size:.9em;letter-spacing:.01em;cursor:pointer;transition:opacity .2s ease;';
    if (!variants.length) button.style.opacity = '.5';
    form.appendChild(button);
    purchase.appendChild(form);
    purchase.appendChild(status);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (button.disabled) return;
      const previous = copy.add;
      button.disabled = true;
      button.textContent = copy.adding;
      status.textContent = '';

      try {
        const data = new FormData(form);
        const r = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          body: data,
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!r.ok) {
          let msg = '';
          try { msg = (await r.json()).description || ''; } catch (_) {}
          throw new Error(msg || 'cart');
        }
        await r.json();
        button.textContent = copy.added;
        status.innerHTML = `<a href="${root}cart" style="color:inherit;text-decoration:underline;text-underline-offset:2px;">${copy.view}</a>`;
        await refreshCartCount();
        document.dispatchEvent(new CustomEvent('siluxe:cart:updated', { bubbles: true }));
        setTimeout(() => {
          button.disabled = false;
          button.textContent = previous;
        }, 1800);
      } catch (err) {
        button.disabled = false;
        button.textContent = copy.error;
        status.textContent = err && err.message && err.message !== 'cart' ? err.message : '';
        setTimeout(() => { button.textContent = previous; }, 2200);
      }
    });
  }

  async function init() {
    const sections = listingSections();
    if (!sections.length) return;
    const anchors = sections.flatMap((section) => Array.from(section.querySelectorAll('a[href*="/products/"]')));
    await Promise.all(anchors.map(enhanceCard));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();